import React, { useState } from "react";
import { Table, Card, Button, Spinner, Alert, Form, InputGroup } from "react-bootstrap";
import { FaPrint, FaSearch } from "react-icons/fa";
import api from "../../axiosConfig";

export default function RaportIstoricSasiu({ tipDeviz = "" }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!search.trim()) return;
    
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/comenzi/interna/rapoarte/istoric-reparatii", {
        params: { search: search.trim(), ...(tipDeviz ? { tipcomanda_id: tipDeviz } : {}) },
      });
      setData(res.data);
    } catch (err) {
      setData([]);
      console.error(err);
      setError("Eroare la încărcarea istoricului.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Istoric Reparații / Foaie Parcurs (Service)</h4>
        <Button variant="primary" onClick={() => window.print()} className="d-print-none">
          <FaPrint className="me-1" /> Printează
        </Button>
      </div>

      <Card className="shadow-sm border-0 mb-4 d-print-none">
        <Card.Body>
          <Form onSubmit={handleSearch}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Caută după Șasiu / VIN, Nr. Auto sau Client..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Button type="submit" variant="primary"><FaSearch /> Caută</Button>
            </InputGroup>
          </Form>
        </Card.Body>
      </Card>

      <Card className="shadow-sm border-0">
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {loading ? (
            <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
          ) : (
            <div className="table-responsive">
              <Table bordered hover className="align-middle">
                <thead className="table-light text-center">
                  <tr>
                    <th>Deviz</th>
                    <th>Data</th>
                    <th>Tip deviz</th>
                    <th>Auto / Șasiu</th>
                    <th>Client</th>
                    <th>Piese / Materiale</th>
                    <th>Manoperă / Lucrări</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-4">
                        {search ? "Nu au fost găsite reparații pentru acest criteriu." : "Introduceți un criteriu de căutare pentru a vizualiza istoricul."}
                      </td>
                    </tr>
                  ) : (
                    data.map((row, idx) => (
                      <tr key={idx}>
                        <td className="text-center">#{row.bxnumar_comanda}</td>
                        <td className="text-center">{String(row.bxdata || "").slice(0, 10)}</td>
                        <td>{row.tipcomanda_id === 2 ? "Clienți" : row.tipcomanda_id === 1 ? "Intern" : "-"}</td>
                        <td>
                          <strong>{row.bxnr_auto}</strong>
                          <br/><small className="text-muted">{row.bxsasiu}</small>
                        </td>
                        <td>{row.client}</td>
                        <td>
                          {row.piesa_cod ? `[${row.piesa_cod}] ${row.piesa_denumire} (x${row.piesa_cantitate})` : "-"}
                        </td>
                        <td>
                          {row.manopera_denumire ? `${row.manopera_denumire} (${row.manopera_ore}h)` : "-"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
      <style>{`
        @media print {
          .d-print-none, .navbar, .sidebar { display: none !important; }
          body { background: white; padding: 0; margin: 0; }
          .container-fluid { padding: 0; }
          .card { border: none !important; box-shadow: none !important; }
        }
      `}</style>
    </div>
  );
}
